import { Transition } from '@headlessui/react'
import { Fragment, ReactNode } from 'react'

/**
 * @return {React.ElementType<any>} Animation for Transition
 */
export function AnimationTransition({ children, show }: { children: ReactNode; show: boolean }) {
  return (
    <Transition
      show={show}
      as={Fragment}
      enter="ease-in duration-150"
      enterFrom="transform opacity-0"
      enterTo="transform opacity-100"
      leave="ease-out duration-250"
      leaveFrom="transform opacity-100 "
      leaveTo="transform opacity-0"
    >
      {children}
    </Transition>
  )
}

/**
 * @return {React.ElementType<any>} Animation for Transition sliding right
 */
export function TransitionRight({ children }: { children: ReactNode }) {
  return (
    <Transition
      as={Fragment}
      enter="transition ease-out duration-1000"
      enterFrom="transform -translate-x-[150vw]"
      enterTo="transform translate-x-none"
      leave="transition ease-in duration-1000"
      leaveFrom="transform translate-x-none"
      leaveTo="transform -translate-x-[150vw]"
    >
      {children}
    </Transition>
  )
}
